import { getTokens } from "./utils";

export interface UserTokenInfo {
    name: string;
    email: string;
}

export function currentUserTokenInfo(): UserTokenInfo | undefined {
    const tokens = getTokens();

    if (!tokens || !tokens.auth_token) {
        return undefined;
    }

    return parseJwt(tokens.auth_token);
}

function parseJwt(token: string): any {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
}
